import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {MergeQueueLink} from './MergeQueueLink'

// Mirrors MergeQueues::Entry::RemovalReason and the copy in
// PullRequests::TimelineEvents::MergeQueueEventComponent#event_description.
const UNKNOWN_REASON_SUFFIX = 'due to an unknown reason'

const REMOVAL_REASON_SUFFIX: Partial<Record<string, string>> = {
  already_merged: 'due to it being already merged',
  checks_timed_out: 'due to no response for status checks',
  failed_checks: 'due to failed status checks',
  merge_conflict: 'due to a conflict with the base branch',
  merged: 'due to the pull request being merged',
  manual: 'due to a manual request',
  git_tree_invalid: 'due to an unknown Git error',
  unknown: UNKNOWN_REASON_SUFFIX,
  queue_cleared: 'due to the queue being cleared',
  roll_back: 'due to a roll back',
  invalid_merge_commit: 'due to invalid changes in the merge commit',
  branch_protection_failure: 'due to Branch Protection failures',
  stack_invalidated: 'because a pull request earlier in the stack was removed',
  stack_parent_unmerged: 'because a pull request earlier in the stack was unmerged and was not in the queue',
  stack_out_of_order: 'because the pull requests in the stack were not ordered correctly in the queue',
}

// Legacy serialized values accepted by RemovalReason.deserialize.
const LEGACY_REASON_ALIASES: Partial<Record<string, string>> = {
  merge: 'merged',
  ci_failure: 'failed_checks',
  queue_clear: 'queue_cleared',
}

export function removalReasonSuffix(removalReason: string | undefined): string {
  const reason = removalReason ? (LEGACY_REASON_ALIASES[removalReason] ?? removalReason) : 'unknown'
  return REMOVAL_REASON_SUFFIX[reason] ?? UNKNOWN_REASON_SUFFIX
}

export function RemovedFromMergeQueueText({info}: {info: IssueEventInfo}) {
  const {mergeQueueUrl, removalReason} = info
  return (
    <>
      {'removed this pull request from the '}
      <MergeQueueLink mergeQueueUrl={mergeQueueUrl} />
      {` ${removalReasonSuffix(removalReason)}`}
    </>
  )
}
